/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { Grid } from '@coursera/cds-core';

import ConsumerSearchBarGridItem from 'bundles/composable-page-header-consumer/components/ConsumerSearchBarGridItem';
import LegacyExploreMegaMenuGridItem from 'bundles/composable-page-header-consumer/components/LegacyExploreMegaMenuGridItem';
import MainNavigationWrapper from 'bundles/composable-page-header/components/MainNavigationWrapper';
import NavLinkGridItem from 'bundles/composable-page-header/components/grid-items/NavLinkGridItem';
import CourseraHomeLogo from 'bundles/composable-page-header/components/grid-items/home-logo/CourseraHomeLogo';
import HomeLogoGridItemModule from 'bundles/composable-page-header/components/grid-items/home-logo/HomeLogoGridItemModule';

const styles = {
  flexGrow: css`
    flex-grow: 1;
  `,
};

const LoggedOutConsumerDesktopMainNav = () => {
  return (
    <MainNavigationWrapper>
      <Grid item md={8} lg={7} container alignItems="center" spacing={16}>
        <Grid item>
          <HomeLogoGridItemModule href="/" logos={[<CourseraHomeLogo key="1" />]} />
        </Grid>
        <Grid item>
          <LegacyExploreMegaMenuGridItem renderMenuOnServer />
        </Grid>
        <Grid item css={styles.flexGrow}>
          <ConsumerSearchBarGridItem />
        </Grid>
      </Grid>
      <Grid item md={4} lg={5} container alignItems="center" justifyContent="flex-end">
        <NavLinkGridItem label="Online Degrees" href="/degrees" name="online_degrees" />
        <NavLinkGridItem label="Careers" href="/career-academy" name="online_career" />
      </Grid>
    </MainNavigationWrapper>
  );
};

export default LoggedOutConsumerDesktopMainNav;
